import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import MineLandNode from "./MineLandNode";

const {ccclass, property} = cc._decorator;

/**
 *
 */
@ccclass
export default class PackageEnlargeCapacity extends cc.Component {

    private mParentScript : MineLandNode;

    onLoad () {}

    start () {

    }

    bindData( mineLandNode : MineLandNode ){
        this.mParentScript = mineLandNode;
    }

    onBtnCancel(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.removeFromParent();
        this.node.destroy();
    }

    onBtnUnLock(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.mParentScript.addPackageCapacityCount();
            this.node.removeFromParent();
            this.node.destroy();
        },()=>{

        },()=>{

        },"矿石-解锁背包容量");
    }
}
